import { z } from 'zod'

export const planBuyoutClaimSchema = z.object({
  evidenceSession: z.object({
    id: z.string(),
    ref: z.string(),
    memberId: z.string(),
    status: z.string(),
    created: z.string(),
    evidence: z.array(z.unknown()),
  }),
})

export type PlanBuyoutClaim = z.infer<typeof planBuyoutClaimSchema>
